import { memo } from 'react';
import ItineraryDayCard from './ItineraryDayCard';

/**
 * Renders the full list of V3 day cards.
 */
function ItineraryDayList({ days, onEditDay }) {
  if (!days || days.length === 0) {
    return (
      <div className="py-12 text-center">
        <p className="text-sm text-gray-500">No days in this itinerary.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {days.map((day, i) => (
        <ItineraryDayCard
          key={day.dayIndex ?? i}
          day={day}
          dayNumber={i + 1}
          onEditDay={onEditDay}
          defaultExpanded={days.length <= 3}
        />
      ))}
    </div>
  );
}

export default memo(ItineraryDayList);
